import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
//import { composeWithDevTools } from 'redux-devtools-extension';
//import { forbiddenWordsMiddleware } from "../middleware";

import reducers from "../reducers/reducers";

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  storeEnhancers(applyMiddleware(/*forbiddenWordsMiddleware, */thunk))
);

//const composeEnhancers = composeWithDevTools({
//  // Specify custom devTools options
//});
//const store = createStore(reducers, /* preloadedState, */ composeEnhancers(
//  applyMiddleware(thunk),
//));

export default store;


// WEBPACK FOOTER //
// ./src/store/configureStore.js